import React, { useEffect, useState } from "react";
import { Card, Box, Typography } from "@mui/material";
import api from "../../utils/api";

const GreetingCard = ({ userFullName, currentTime }) => {
  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const res = await api.get("/companies");
        if (Array.isArray(res.data) && res.data.length > 0) {
          setCompanyName(res.data[0].Name);
        } else if (res.data?.Name) {
          setCompanyName(res.data.Name);
        }
      } catch (err) {
        console.error("❌ Failed to fetch company name:", err);
      }
    };
    fetchCompany();
  }, []);

  const parseHour = (timeStr) => {
    const match = timeStr.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i);
    if (!match) return null;
    let [_, hour, minute, meridian] = match;
    hour = parseInt(hour, 10);
    if (meridian.toUpperCase() === "PM" && hour !== 12) hour += 12;
    if (meridian.toUpperCase() === "AM" && hour === 12) hour = 0;
    return hour;
  };

  const getGreeting = () => {
    const hour = parseHour(currentTime);
    if (hour === null) return "Hello";
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  const getFormattedDate = () => {
    const today = new Date();
    return today.toLocaleDateString(undefined, {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <Card
      sx={{
        borderRadius: "18px",
        p: 3,
        background: "linear-gradient(135deg, #2f63ad, #5c8fdb)",
        color: "white",
        mb: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
        backdropFilter: "blur(6px)",
      }}
    >
      {/* Left Section */}
      <Box>
        {companyName && (
          <Typography
            variant="subtitle2"
            sx={{
              opacity: 0.85,
              fontWeight: 500,
              letterSpacing: 0.3,
            }}
          >
            {companyName}
          </Typography>
        )}

        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            mt: 0.5,
          }}
        >
          {getGreeting()}, {userFullName}.
        </Typography>

        <Typography
          sx={{
            mt: 0.75,
            opacity: 0.9,
            fontSize: "0.95rem",
          }}
        >
          Welcome to MyHOA!
        </Typography>
      </Box>

      {/* Right Section */}
      <Box
        sx={{
          textAlign: "right",
          mt: { xs: 2, md: 0 },
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            letterSpacing: 0.5,
          }}
        >
          {currentTime}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            mt: 0.5,
            opacity: 0.9,
          }}
        >
          {getFormattedDate()}
        </Typography>
      </Box>
    </Card>
  );
};

export default GreetingCard;